/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { useRef, useEffect, useState } from 'react';
import { ColorPicker as ReactColorPicker, useColor } from 'react-color-palette';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";
import { Popover } from "../../../../../a";
import { useOutsideClick } from "../../../../../utils";
// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'color-picker';

/**
 * This is the component description.
 */
const ColorPicker = ({
  id,
  className: userClassName,
  style,
  icon,
  defaultColorHex,
  onChange
  // ...otherProps
}) => {
  const [colorValue, setColor] = useColor(defaultColorHex);
  const parentRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  useOutsideClick(parentRef, () => setIsOpen(false));
  useEffect(() => {
    const {
      hex
    } = colorValue;
    if (hex) {
      onChange(hex);
    }
  }, [colorValue]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    React.createElement("div", {
      id: id,
      className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
      style: style,
      ref: parentRef
      // {...otherProps}
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: () => setIsOpen(!isOpen)
    }, /*#__PURE__*/React.createElement("span", {
      className: "icon"
    }, icon), /*#__PURE__*/React.createElement("span", {
      className: "icon"
    }, "V")), /*#__PURE__*/React.createElement(Popover, {
      parentRef: parentRef,
      isOpen: isOpen,
      color: "background-far"
    }, /*#__PURE__*/React.createElement(ReactColorPicker, {
      color: colorValue,
      onChange: setColor,
      hideInput: true
    })))
  );
};
ColorPicker.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The required default hex value for the color picker
   */
  defaultColorHex: PropTypes.string
};
ColorPicker.defaultProps = {
  defaultColorHex: '#ffffff'
};
export default ColorPicker;